import React from 'react';
import { Helmet } from 'react-helmet-async';

const Seo = ({ title, description, path, children }) => {
  const url = `https://www.inviteengine.com${path}`;

  return (
   <Helmet>
      {/* 1. Standard Metadata */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      {/* 2. Open Graph (Facebook/LinkedIn) */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />

      {/* 3. Twitter Cards (Essential for B2B) */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />

      {/* 4. Page-Specific Schema/Scripts */}
      {children} 
    </Helmet>
  );
};

// ADD THIS LINE AT THE VERY BOTTOM
export default Seo;